import React__default from 'react';
import SocialNetworks$1 from './SocialNetworks.js';
import pgaSocialnetworks from './pgaSocialnetworks.js';

var SocialNetworks = (function () {
  return /*#__PURE__*/React__default.createElement(SocialNetworks$1, {
    networks: pgaSocialnetworks
  });
});

export { SocialNetworks as default };
